var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNMemory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6667 6H6.33333C5.71449 6 5.121 6.24583 4.68342 6.68342C4.24583 7.121 4 7.71449 4 8.33333V31.6667C4 32.2855 4.24583 32.879 4.68342 33.3166C5.121 33.7542 5.71449 34 6.33333 34H29.6667C30.2855 34 30.879 33.7542 31.3166 33.3166C31.7542 32.879 32 32.2855 32 31.6667V8.33333C32 7.71449 31.7542 7.121 31.3166 6.68342C30.879 6.24583 30.2855 6 29.6667 6Z",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 19.2221C14.3647 19.2221 15.3539 18.8124 16.0832 18.0831C16.8125 17.3538 17.2222 16.3646 17.2222 15.3332C17.2222 14.3018 16.8125 13.3127 16.0832 12.5834C15.3539 11.8541 14.3647 11.4443 13.3333 11.4443C12.3019 11.4443 11.3128 11.8541 10.5835 12.5834C9.85418 13.3127 9.44446 14.3018 9.44446 15.3332C9.44446 16.3646 9.85418 17.3538 10.5835 18.0831C11.3128 18.8124 12.3019 19.2221 13.3333 19.2221ZM20.9478 21.7266C21.0952 21.5292 21.2873 21.3697 21.5084 21.2611C21.7295 21.1526 21.9732 21.0981 22.2195 21.1021C22.4658 21.1061 22.7076 21.1686 22.925 21.2843C23.1424 21.4 23.3293 21.5657 23.4701 21.7678L30.2951 31.5546C31.0138 32.5859 30.2757 33.9999 29.0196 33.9999H11.7778L20.9478 21.7266Z",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNMemory);
export default __webpack_public_path__ + "static/media/NMemory.6ac5fbf54f28cf43701bc4b129b99688.svg";
export { ForwardRef as ReactComponent };